import { ContextFormFieldText } from '@bambi/component-library/src/components/forms/context/ContextFormFieldText';
import { ContextFormFieldTextArea } from '@bambi/component-library/src/components/forms/context/ContextFormFieldTextArea';

import { ContextFormFieldLocationTypeahead } from 'src/common/FormField/v2/context/ContextFormFieldLocationTypeahead';
import { ContextFormFieldSwitch } from 'src/common/FormField/v2/context/ContextFormFieldSwitch';

export function PassengerAddressForm() {
  return (
    <div className="flex flex-col gap-4">
      <ContextFormFieldText fieldPath="name" label="Name" />
      <ContextFormFieldLocationTypeahead fieldPath="address" label="Address" />
      <div className="flex flex-row gap-4">
        <ContextFormFieldSwitch
          fieldPath="is_primary_address"
          label="Is Primary"
        />
        <ContextFormFieldSwitch
          fieldPath="is_billing_address"
          label="Is Billing"
        />
      </div>
      <ContextFormFieldTextArea
        fieldPath="address_notes"
        label="Address Notes"
      />
      <ContextFormFieldTextArea
        fieldPath="address_details"
        label="Address Details"
      />
    </div>
  );
}
